import React, { FC, ReactNode, RefObject, useEffect } from 'react';
import { useRouter } from 'next/router';
import { styled } from 'linaria/react';
import { withTheme } from '@shared/lib/theme';
import { SearchIcon } from '@shared/assets/icons';
import { useModal } from '@shared/lib';
import { homeSearchClickGtm } from '@shared/lib/gtm/redesign';
interface SuggestModalProps {
  open: boolean;
  onClose: () => void;
  navbarRef: RefObject<HTMLElement>;
}
interface SearchButtonProps {
  navbarRef: RefObject<HTMLElement>;
  isAtTop: boolean;
  renderSearchModal: (props: SuggestModalProps) => ReactNode;
}
const SearchButton: FC<SearchButtonProps> = ({
  navbarRef,
  isAtTop,
  renderSearchModal
}) => {
  const router = useRouter();
  const {
    isModalActive,
    handleModalOpen,
    handleModalClose
  } = useModal();
  useEffect(() => {
    handleModalClose();
  }, [router.asPath]);
  return <>
      <SearchButtonWrapper isAtTop={isAtTop} onClick={() => {
      homeSearchClickGtm();
      handleModalOpen();
    }}>
        <SearchIcon />
      </SearchButtonWrapper>
      {renderSearchModal({
      open: isModalActive,
      onClose: handleModalClose,
      navbarRef
    })}
    </>;
};
export default SearchButton;
interface SearchButtonWrapperProps {
  isAtTop: boolean;
}
const _exp = /*#__PURE__*/() => ({
  isAtTop
}) => isAtTop ? '4rem' : '3rem';
const _exp2 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.accent;
const _exp3 = /*#__PURE__*/() => ({
  theme
}) => theme.colors.background.hover;
const SearchButtonWrapper = withTheme(/*#__PURE__*/styled('button')({
  name: "SearchButtonWrapper",
  class: "siwe5jf",
  propsAsIs: false,
  vars: {
    "siwe5jf-0": [_exp()],
    "siwe5jf-1": [_exp2()],
    "siwe5jf-2": [_exp3()]
  }
}));

require("./SearchButton.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./SearchButton.tsx");